module.exports = __webpack_public_path__ + "MV.png?c8960c1d7236c1e98e9b8dde85bdae47";